import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BleDropdownComponent, FilterInput} from './ble-dropdown/ble-dropdown.component';
import {MatSelectModule} from '@angular/material/select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MAT_DATE_LOCALE, MatNativeDateModule} from '@angular/material/core';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatInputModule} from '@angular/material/input';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatTimepickerModule} from "mat-timepicker";
import {MatTooltipModule} from "@angular/material/tooltip";
import {BleDatepickerComponent} from "./ble-datepicker/ble-datepicker.component";
import {BleInputTimeComponent} from "./ble-input-time/ble-input-time.component";
import {BleInputComponent} from "./ble-input/ble-input.component";
import {BleInputTextareaComponent} from "./ble-input-textarea/ble-input-textarea.component";
import {BlePasswordComponent} from "./ble-password/ble-password.component";
import {DatepickerHeaderComponent} from "./ble-datepicker/datepicker-header/datepicker-header.component";
import {BleCheckboxComponent} from "./ble-checkbox/ble-checkbox.component";
import {BleSlideComponent} from "./ble-slide/ble-slide.component";
import {BleInputNumberComponent} from "./ble-input-number/ble-input-number.component";
import {DatetimepickerHeaderComponent} from "./ble-datetimepicker/datepicker-header/datetimepicker-header.component";
import {BleDatetimepickerComponent} from "./ble-datetimepicker/ble-datetimepicker.component";
import {MatTreeModule} from "@angular/material/tree";
import {InputTreeComponent} from "./input-tree/input-tree.component";
import {
    NgxMatDatetimePickerModule,
    NgxMatNativeDateModule,
    NgxMatTimepickerModule
} from "@angular-material-components/datetime-picker";

// const lang = configuration.language == 'it' ? 'it-IT' : 'en-EN';

@NgModule({
  declarations: [
    BleDropdownComponent,
    BleDatepickerComponent,
    BleInputComponent,
    BleInputTimeComponent,
    BleInputNumberComponent,
    BleInputTextareaComponent,
    BlePasswordComponent,
    DatepickerHeaderComponent,
    DatetimepickerHeaderComponent,
    FilterInput,
    BleCheckboxComponent,
    BleSlideComponent,
    InputTreeComponent,
    BleInputTimeComponent,
    BleDatetimepickerComponent
      ],
  imports: [
    CommonModule,
    MatSelectModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatAutocompleteModule,
    MatInputModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatProgressBarModule,
    MatSlideToggleModule,
	MatTreeModule,
    MatTooltipModule,
    MatTimepickerModule,
    MatTooltipModule,
    NgxMatDatetimePickerModule,
    NgxMatTimepickerModule,
    NgxMatNativeDateModule
  ],
  exports: [
    BleDropdownComponent,
    BleDatepickerComponent,
	BleDatetimepickerComponent,
    BleInputComponent,
    BleInputTimeComponent,
    BleInputNumberComponent,
    BleInputTextareaComponent,
    BlePasswordComponent,
    BleCheckboxComponent,
    BleSlideComponent,
	InputTreeComponent,
    BleInputTimeComponent,
  ],
  providers: [{ provide: MAT_DATE_LOCALE, useValue: 'it-IT' }]
})
export class BleInputModule { }
